import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/index';
import { DomSanitizer } from '@angular/platform-browser';
import { ConnectionService } from '@services/connection-service';
import { fromSelectors } from '@store/selectors';
import { fromActions } from '@store/actions';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'support-ticket-list',
  templateUrl: './support-ticket-list.html',
  styleUrls: ['./support-ticket-list.scss'],
  standalone: false,
})
export class SupportTicketListComponent implements OnInit, OnDestroy {
  user: any;
  subscription: Subscription[] = [];
  activeQueries$: Observable<any[]>;
  pastQueries$: Observable<any[]>;
  pendingResponseMap: any;
  isNewHelpUiExp: boolean = false;
  recentSupportTickets$: Observable<any[]> = this.store.select(fromSelectors.selectAllSupportTicket);
  inProcess$: Observable<boolean> = this.store.select(fromSelectors.selectRecentTicketFetchInProcess);
  readonly isPastQueriesRoute: boolean;

  get showNewHelpTicketList(): boolean {
    return !this.isPastQueriesRoute && this.isNewHelpUiExp;
  }

  get showLegacyTicketList(): boolean {
    return !this.isPastQueriesRoute && !this.isNewHelpUiExp;
  }

  constructor(private conn: ConnectionService,
    private store: Store,
    public appConfig: AppConfig,
    public domSanitizer: DomSanitizer,
    activatedRoute: ActivatedRoute) {
    this.isPastQueriesRoute = activatedRoute.snapshot.queryParamMap.get('view') === 'past-queries';
    this.store.dispatch(fromActions.SupportRecentTicketFetchBegin({}));
  }

  async ngOnInit(): Promise<void> {
    if (this.isPastQueriesRoute) return;
    this.user = this.conn.getActingUser();
    await this.fetchActiveExperiments();
  }

  async fetchActiveExperiments(): Promise<void> {
    const experiments = await this.conn.findUserActiveExperiments();
    experiments.forEach(async (each: any): Promise<void> => {
      if (each.key === 'new_help_ui') {
        this.isNewHelpUiExp = true;
        await this.getPendingResponseMap();
        await this.getActiveAndPastQueries();
      };
    });
  }

  async getPendingResponseMap(): Promise<void> {
    this.pendingResponseMap = await this.conn.findAllPendingTicketWithAwaitingResponse();
  }

  getActiveAndPastQueries(): void {
    this.activeQueries$ = this.recentSupportTickets$.pipe(
      map(tickets => tickets.filter(ticket => ticket.status === this.appConfig.Shared.Ticket.status.Pending ||
        ticket.status === this.appConfig.Shared.Ticket.status.RequestClosure))
    );
    
    this.pastQueries$ = this.recentSupportTickets$.pipe(
      map(tickets => tickets.filter(ticket => ticket.status === this.appConfig.Shared.Ticket.status.Completed))
    );
  }

  async viewQuery(query: { [key: string]: any }): Promise<void> {
    await this.conn.navigateToURL(`/support/ticket/${query.objectId}?username=${this.user.get('username')}`);
  }

  async back(): Promise<void> {
    await this.conn.navigateToURL(`/support?username=${this.user.get('username')}`);
  }

  ngOnDestroy(): void {
    this.subscription.forEach((each: Subscription): void => each.unsubscribe());
  }
}
